import { useEffect, useState } from "react";
import { FadeLoader } from "react-spinners";
import "./Loader.css";

const Loader = ({ isLoading }) => {
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(isLoading);
    }, [isLoading]);
    return (
        <>
            {loading && (
                <div className="loader-overlay">
                    <FadeLoader size={400} color={"#5bdfc1"} loading={loading} />
                </div>
            )}
        </>
    )
}

export default Loader
